/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from './DropDown';
import RoundButton from './RoundButton';

interface Props {
  pageSize: number;
  pageNumber: number;
  total: number;
  onChangePage: (value: number) => void;
  onChangeSize?: (value: number) => void;
}

const TablePagination: React.FC<Props> = ({
  pageSize,
  pageNumber,
  total,
  onChangeSize,
  onChangePage,
}) => {
  const { t } = useTranslation();

  const pageSizes = [
    { id: 5, text: '5' },
    { id: 10, text: '10' },
    { id: 15, text: '15' },
  ];
  const from = (pageNumber - 1) * pageSize + 1;
  const isLastPage = total <= pageNumber * pageSize;
  const to = isLastPage ? total : pageNumber * pageSize;

  return total === 0 ? null : (
    <div className="paginator">
      {onChangeSize && (
        <>
          <span>{t('rowsPerPage')}</span>
          <Dropdown
            className="sizeselect"
            size="sm"
            elements={pageSizes}
            value={pageSize}
            onChange={(ps: number) => onChangeSize(ps)}
          />
        </>
      )}
      <span>{t('pageLegend', { from, to, total })}</span>
      <div className="page-actions">
        <RoundButton
          className="secondary"
          disabled={pageNumber === 1}
          onClick={() => onChangePage(pageNumber - 1)}
          icon="chevron-left"
        />
        <RoundButton
          className="secondary"
          disabled={isLastPage}
          onClick={() => onChangePage(pageNumber + 1)}
          icon="chevron-right"
        />
      </div>
    </div>
  );
};

export default React.memo(
  TablePagination,
  (prevProps, nextProps) =>
    prevProps.pageSize === nextProps.pageSize &&
    prevProps.pageNumber === nextProps.pageNumber &&
    prevProps.total === nextProps.total
);
